module.exports = __webpack_public_path__ + "static/img/welcome-monitor.f411b59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/welcome-monitor.png
// module id = Yffg
// module chunks = 1